"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("@mui/material"),r=require("@mui/material/styles"),o=require("../../appointment-schedule.constants.js"),n=r.styled(a.Button,{shouldForwardProp:t=>t!=="top"})(({theme:t,top:e})=>`
  background: ${t.palette.primary[800]}; // aqua mapped to primary
  position: absolute;
  right: 0;
  padding: 0;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  min-width: ${o.ADD_BUTTON_COLUMN_WIDTH}px;
  width: ${o.ADD_BUTTON_COLUMN_WIDTH}px;
  height: 16px;
  border-radius: 50%;
  color: ${t.palette.common.white};
  top: ${e}%;
  z-index: 3;
  transform: translate(4px, -4px);
 `),l=r.styled("div",{})``,p=r.styled("div",{shouldForwardProp:t=>t!=="isExtended"&&t!=="width"&&t!=="isDayView"})(({theme:t,width:e})=>`
  color: ${t.palette.grey[400]};
  background: transparent;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  margin: 0;
  position: relative;
  border-right: 1px solid ${t.palette.grey[300]};
  width: ${e?`${e}%`:`${o.EXTENDED_COLUMN_WIDTH}px`};
`),d=r.styled("div",{shouldForwardProp:t=>t!=="top"&&t!=="height"})(({theme:t,top:e,height:i})=>`
  position: absolute;
  top: ${e??0}%;
  left: 0;
  height: ${i??0}%;
  background-image: linear-gradient(
    45deg,
    ${t.palette.grey[300]} 25%,
    ${t.palette.grey[100]} 25%,
    ${t.palette.grey[100]} 50%,
    ${t.palette.grey[300]} 50%,
    ${t.palette.grey[300]} 75%,
    ${t.palette.grey[100]} 75%,
    ${t.palette.grey[100]} 100%
  );
  background-size: 15px 15px;
  color: ${t.palette.grey[600]};
  width: calc(100% + ${o.ADD_BUTTON_COLUMN_WIDTH}px);
  padding: 4px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
`),s=r.styled("div",{shouldForwardProp:t=>t!=="top"&&t!=="height"})(({theme:t,top:e,height:i})=>`
  position: absolute;
  top: ${e??0}%;
  left: 0;
  height: ${i??0}%;
  background: ${t.palette.error[500]};
  color: ${t.palette.grey[600]};
  width: 100%;
  padding: 4px;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 3;
`),g=r.styled("div")`
  width: calc(100% - ${o.ADD_BUTTON_COLUMN_WIDTH}px);
  position: relative;
`,c=r.styled("div")`
  width: ${o.ADD_BUTTON_COLUMN_WIDTH-o.COLUMN_MARGIN}px;
  position: relative;
  margin-left: ${o.COLUMN_MARGIN}px;
`;exports.AppointmentGroupWrapper=l;exports.BlockerSlot=s;exports.DetailsWrapper=g;exports.NonWorkingSlot=d;exports.OverbookedButtonsWrapper=c;exports.ShowMoreButton=n;exports.TimeDetails=p;
